import React, { useState } from "react";
import QuoteModal from "./QuoteModal";

export default function GetAQuote() {

  const [openModal, setOpenModal] = useState(false);

  return (
    <>
      <button
        className="button"
        onClick={() => setOpenModal(true)}
      >
        <span>Get a Quote</span>
      </button>

      <QuoteModal
        show={openModal}
        handleClose={() => setOpenModal(false)}
      />
    </>
  );
}